@if (isLoading()) {
  <app-loading />
} @else {
  <div *transloco="let t; prefix: 'project'" data-testid="system-recording-tab-page">
    <div class="card">
      <app-card-title key="project.steps.system.recording" />
      <h3 class="font-semibold mb-3">
        {{ 'project.steps.systemRecording.legend' | transloco }}
      </h3>
      <div class="flex flex-col gap-3 mb-6">
        <div class="flex items-center gap-3">
          <div
            class="w-2 h-2 bg-primary rounded-full"
            data-testid="system-recording-legend-in-scope"
          ></div>
          <span class="text-sm opacity-80">{{
            'project.steps.systemRecording.inScope' | transloco
          }}</span>
        </div>
      </div>

      <div class="flex flex-col space-y-4">
        @for (module of moduleData(); track module.id) {
          <app-system-recording-module-hr [moduleData]="module" [isReadOnly]="isButtonDisabled()" />
        }
        <app-system-recording-module-non-hr
          [projectId]="projectId"
          [isReadOnly]="isButtonDisabled()"
        />
      </div>

      <app-audit-info [auditInfo]="auditInfo()" />
    </div>
  </div>
}
